import angular from 'angular';
import tableGridIconCellComponent from './tableGridIconCell.component';

let tableGridIconCellModule = angular.module('tableGridIconCell', []).directive('tableGridIconCell', tableGridIconCellComponent);

export default tableGridIconCellModule;



// WEBPACK FOOTER //
// ./app/components/tableGridIconCell/tableGridIconCell.js